import { apiAxios } from './axios';
import {
  FileApi,
  LoggingApi,
  LoginCheckApi,
  LogoutApi,
  MarketApi,
  MarketComponentApi,
  MarketComponentArticleTypeApi,
  MarketComponentHistoryApi,
  MarketComponentTypeApi,
  ReportingApi,
  UserApi,
  UserMarketsApi,
  UserProfileApi,
  VersionApi,
} from '../generated/fresh-guard-api';
import { getApiBaseUrl } from '../tools/ConfigurationReader.ts';

export const api = {
  userApi: new UserApi(undefined, getApiBaseUrl(), apiAxios),
  reportingApi: new ReportingApi(undefined, getApiBaseUrl(), apiAxios),
  marketApi: new MarketApi(undefined, getApiBaseUrl(), apiAxios),
  marketComponentApi: new MarketComponentApi(undefined, getApiBaseUrl(), apiAxios),
  versionApi: new VersionApi(undefined, getApiBaseUrl(), apiAxios),
  logoutApi: new LogoutApi(undefined, getApiBaseUrl(), apiAxios),
  userMarketsApi: new UserMarketsApi(undefined, getApiBaseUrl(), apiAxios),
  fileApi: new FileApi(undefined, getApiBaseUrl(), apiAxios),
  loggingApi: new LoggingApi(undefined, getApiBaseUrl(), apiAxios),
  loginCheckApi: new LoginCheckApi(undefined, getApiBaseUrl(), apiAxios),
  userProfileApi: new UserProfileApi(undefined, getApiBaseUrl(), apiAxios),
  marketComponentTypeApi: new MarketComponentTypeApi(undefined, getApiBaseUrl(), apiAxios),
  marketComponentArticleTypeApi: new MarketComponentArticleTypeApi(
    undefined,
    getApiBaseUrl(),
    apiAxios
  ),
  marketComponentHistoryApi: new MarketComponentHistoryApi(undefined, getApiBaseUrl(), apiAxios),
};
